import axiosInstance from '../axiosInterceptor/axiosInstance'

// The game's boxscore, read under the org whose CMS is shown (a paired club passes the federation).
const getGameStats = async ({ gameId, orgId }) => {
  const response = await axiosInstance.get(`v1/orgs/${orgId}/stats/games/${gameId}`)
  return response?.data
}

export default getGameStats
